import Checked from "./assets/checked.svg";
import { compose } from "redux";
import withTranslations from "../../../../../../../hocs/withTranslations";
import React from "react";
import LandingTypography from "../../../Homepage/components/LandingTypography";
import withPaymentDetails from "../../../../../../../hocs/withPaymentDetails";
import hasUpgraded from "./utils/hasUpgraded";
import Loader from "../../../../../common/Loader";
import { useLocation } from "react-router";
import hasDowngraded from "./utils/hasDowngraded";
import convertSecondsToDaysToDays from "../../utils/convertSecondsToDays";
import PlansErrorPage from "./plansErrorPage";
import withUserData from "../../../../../../../hocs/withUserData";

const SuccessPage = ({
  translate,
  paymentDetails,
  userData,
  loginLoading,
  loading: paymentDetailsLoading
}) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const isError501 = params.get("error") === "501";

  if (isError501) {
    return <PlansErrorPage />;
  }

  if (paymentDetailsLoading || loginLoading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  const hasSubscription = paymentDetails?.has_subscription;
  const planName = paymentDetails?.plan_name ?? userData?.current_plan?.name;

  if (hasUpgraded({ paymentDetails })) {
    return (
      <Wrapper translate={translate}>
        <h1
          className={"mt-5 mb-4 text-2xl font-semibold text-black text-center"}
        >
          {hasSubscription
            ? translate("success-page_upgrade-title_subscription")
            : translate("success-page_upgrade-title")}
        </h1>
        <p
          className={"text-xs text-black-8 max-w-90"}
          dangerouslySetInnerHTML={{
            __html: translate(
              "success-page_upgrade-paragraph %{newPlanName}",
              {
                newPlanName: planName
              }
            )
          }}
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper translate={translate}>
      <h1
        className={"mt-5 mb-4 text-2xl font-semibold text-black text-center"}
      >
        {hasDowngraded({ paymentDetails })
          ? hasSubscription
            ? translate("success-page_downgrade-title_subscription")
            : translate("success-page_success-title")
          : translate("success-page_success-title")}
      </h1>
      <p
        className={"text-xs text-black-8 max-w-90"}
        dangerouslySetInnerHTML={{
          __html: hasDowngraded({ paymentDetails })
            ? hasSubscription
              ? translate("success-page_downgrade-paragraph_subscription", {
                  newPlanName: paymentDetails?.last_plan_change?.to_plan,
                  userCurrentPlanName: planName,
                  userCurrentDays: convertSecondsToDaysToDays(
                    paymentDetails?.end_date_in_seconds
                  )
                })
              : translate(
                  "success-page_downgrade-paragraph_no-subscription",
                  {
                    newPlanName: paymentDetails?.last_plan_change?.to_plan,
                    userCurrentPlanName: planName,
                    userCurrentDays: convertSecondsToDaysToDays(
                      paymentDetails?.end_date_in_seconds
                    )
                  }
                )
            : translate("success-page_success-paragraph %{newPlanName}", {
                newPlanName: planName
              })
        }}
      />
    </Wrapper>
  );
};

const Wrapper = ({ children, translate }) => {
  return (
    <LandingTypography className={"plans"}>
      <div className={"flex flex-col align-center text-center mt-14"}>
        <img
          src={Checked}
          alt={translate("Success icon")}
          height={48}
          width={48}
        />
        {children}
      </div>
    </LandingTypography>
  );
};

export default compose(
  withTranslations,
  withPaymentDetails,
  withUserData
)(SuccessPage);
